import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from 'src/app/app.service';
import { UserPhoneLogin } from 'src/app/interfaces/user/UserForAuthenticatio.model';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';
import { TokenStorageService } from '../../_services/token-storage.service';

@Component({
  selector: 'app-external-sign-in',
  templateUrl: './external-sign-in.component.html',
  styleUrls: ['./external-sign-in.component.css']
})
export class ExternalSignInComponent implements OnInit {
  private sub: any;
  private otp: any;
  private mobileNumber: any;
  isLoggedIn = false;
  role: string = '';
  constructor(private activatedRoute: ActivatedRoute, public appService: AppService,
    private _authService: AuthenticationService, private tokenStorage: TokenStorageService,
    private _router: Router
  ) { }

  ngOnInit(): void {
    debugger;
    this._router.onSameUrlNavigation = 'reload';
    this.sub = this.activatedRoute.params.subscribe(params => {
      this.otp = params['otp'];
      this.mobileNumber = params['mobileNumber'];
      this.loginUser();

    });
  }



  public loginUser = () => {

    const userForAuthPhone: UserPhoneLogin = {
      otp: this.otp,
      mobileNumber: this.mobileNumber
    }
    this._authService.verifyOTP(`api/Login/VerifyOtp?OTP=${userForAuthPhone.otp}&mobileNumber=${userForAuthPhone.mobileNumber}`, userForAuthPhone)
      .subscribe(res => {
        this.tokenStorage.saveToken(res.token);
        this.tokenStorage.saveUser(res);
        this.isLoggedIn = true;
        this.role = this.tokenStorage.getUser().role;

        this._authService.sendAuthStateChangeNotification(res.isAuthSuccessful);
        this._router.routeReuseStrategy.shouldReuseRoute = () => false;
        this._router.onSameUrlNavigation = 'reload';
        if (this.role.toLowerCase() != 'admin')
          this._router.navigate(['/home']);
        else
          this._router.navigate(['/admin/products']);
      },
        (error) => {
          console.log("External login failed");
        })

  }
}
